import React from 'react';

import './carousel.basic.scss';

const CarouselComponentBasic: React.FC<any> = props => (
    <div className="carousel-root">
        <div className="carousel carousel-slider">
            <div className="slider-wrapper">
                <ul className="slider">
                    <li className="slide">
                        <div className="slide__content">
                            {
                                React.Children.map(props.children, (child, idx) => (
                                    React.cloneElement(
                                        child, { style: { display: idx === 0 ? 'flex' : 'none' } }
                                    )
                                ))
                            }
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
);

export default CarouselComponentBasic;
